module.exports = __webpack_public_path__ + "img/bandicam_00000.a8d5f0e8.png";